import setCurrentPage from "src/Utils/setCurrentPage";
import Config from "src/Constants/Config";
import store from "src/Reducers/store";
import { useSelector } from "react-redux";

import "./index.sass";
import { Button, ButtonGroups } from "@nocios/presentation-kit";
import React, { useEffect } from "react";

interface CustomProps {
  pageId: number;
  children: React.ReactNode;
  showBack?: boolean;
  showNext?: boolean;
  customBackPageId?: number;
  customNextPageId?: number;
  customNextProps?: any;
  showLogos?: boolean;
}

const Custom = ({
  pageId,
  children,
  showBack = true,
  showNext = true,
  customBackPageId,
  customNextPageId,
  customNextProps,
  showLogos = false,
}: CustomProps) => {
  const arrowLeft = `${Config.BASE_URL}/images/icons/arrow-left.png`;
  const arrowRight = `${Config.BASE_URL}/images/icons/arrow-right.png`;

  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const btns = [
    {
      label: "Back",
      type: "back",
      startIcon: arrowLeft,
      onClick: () => setCurrentPage(pageId - 1),
    },
    {
      label: "Continue",
      type: "next",
      endIcon: arrowRight,
      onClick: () => setCurrentPage(pageId + 1),
    },
  ];

  const [btnBack, setBtnBack] = React.useState({ ...btns[0] });
  const [btnNext, setBtnNext] = React.useState({ ...btns[1] });

  useEffect(() => {
    if (pageId === currentPage) {
      console.log("currentPage", currentPage);
      console.log("customBackPageId", customBackPageId);
      console.log("customNextPageId", customNextPageId);
      if (customBackPageId !== null && customBackPageId !== undefined) {
        setBtnBack({ ...btns[0], onClick: () => setCurrentPage(customBackPageId) });
      }

      if (customNextPageId !== null && customNextPageId !== undefined) {
        setBtnNext({ ...btns[1], onClick: () => setCurrentPage(customNextPageId) });
      }
    }
    // eslint-disable-next-line
  }, [currentPage, customBackPageId, customNextPageId]);

  useEffect(() => {
    if (pageId === currentPage) {
      if (customNextProps) {
        setBtnNext({ ...btnNext, ...customNextProps });
      }
    }
    // eslint-disable-next-line
  }, [customNextProps]);

  return (
    <>
      {pageId === currentPage && (
        <div className="custom-center-content">
          <div className="custom-center-content-body">{children}</div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <ButtonGroups>
              {showBack && <Button {...btnBack} />}
              {showNext && <Button {...btnNext} />}
            </ButtonGroups>
            {showLogos ? <img style={{ width: "var(--width-752)" }} src={`${Config.BASE_URL}/images/logos.png`} alt="" /> : <div></div>}
          </div>
        </div>
      )}
    </>
  );
};

export default Custom;
